export let mozaicHostElement: HTMLElement | null = null;

export function setMozaicHostElement(element: HTMLElement): void {
    mozaicHostElement = element;
}
